import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1_8)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M43.6364 12H20.3636C9.1171 12 0 20.9543 0 32C0 43.0457 9.1171 52 20.3636 52H43.6364C54.8829 52 64 43.0457 64 32C64 20.9543 54.8829 12 43.6364 12Z",
			fill: "#000091"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M30 32.0001C30 24.268 36.2679 18 43.9999 18C51.7319 18 58 24.2681 58 32.0001C58 39.7321 51.732 46 43.9999 46C36.2679 46 30 39.7321 30 32.0001Z",
			fill: "#F95C5E",
			stroke: "white",
			strokeWidth: 4
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1_8",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white"
		})
	}) })]
});
export default SvgLogo;
